import React, { useCallback, useEffect } from 'react';
import { WarningCircleFillIcon } from '@chegg-ui/horizon-icons';
import { colors } from '@chegg-ui/theme';
import { spacing } from '@chegg-ui/theme';
import { componentViewEventGeneralError, interactionTryAgain } from "../../../common/rio/rio";
import { FlexWrapperSC, LinkSC, LogoSC, MarginBottomSC, TypographySC } from "../../../common/styles/common.styles";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { changeRoute } from "../../../store/slices/router";
import { getTexts } from "../../../utils/texts";
export var GeneralError = function GeneralError() {
  var _getTexts = getTexts(),
    generalError = _getTexts.errorMessages.generalError;
  var dispatch = useAppDispatch();
  var currentRoute = useAppSelector(function (state) {
    return state.router.current_route;
  });
  useEffect(function () {
    componentViewEventGeneralError(currentRoute);
  }, [currentRoute]);
  var onLinkClickCb = useCallback(function () {
    interactionTryAgain(currentRoute);
    dispatch(changeRoute('/'));
  }, [dispatch, currentRoute]);
  return /*#__PURE__*/React.createElement(FlexWrapperSC, {
    "data-test": "general_error_modal"
  }, /*#__PURE__*/React.createElement(LogoSC, null, /*#__PURE__*/React.createElement(WarningCircleFillIcon, {
    size: "large",
    color: colors.red700
  })), /*#__PURE__*/React.createElement(TypographySC, {
    variant: "h2",
    variantType: "bold"
  }, generalError.title), /*#__PURE__*/React.createElement(MarginBottomSC, {
    marginBottom: spacing.px16
  }), /*#__PURE__*/React.createElement(TypographySC, {
    variant: "body1",
    variantType: "paragraph",
    "data-test": "general_error_subtitle"
  }, generalError.footer, /*#__PURE__*/React.createElement(LinkSC, {
    "data-test": "general_error_footer_link",
    onClick: onLinkClickCb
  }, generalError.footerLink)));
};